import { Injectable, Component } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { Http } from '@angular/http';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map'

@Injectable()
export class AuthGuard implements CanActivate {
    public constructor(private router: Router, private jwt: JwtHelper) {}
    canActivate() {
        let token = localStorage.getItem('amt_flyer_token');
        if(token == null) {
            this.router.navigate(['/sign-in']);
            return false;
        }
        if(this.jwt.isTokenExpired(token)) {
            this.router.navigate(['/sign-in']);
            return false;
        }
        return true;
    }
}

@Component({
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {
    private signinForm: FormGroup;
    private submitted: boolean = false;
    private errors:{email: string, password: string, generic: string} = {email: '', password: '', generic: ''};

    public constructor(private formBuilder: FormBuilder, private http: Http, private router: Router) {
        this.errors.email = 'You must provide a valid email address.';
        this.errors.password = 'You must provide a valid email address.';

        this.signinForm = this.formBuilder.group({
            'email': new FormControl({value: '', disabled: false}, Validators.required),
            'password': new FormControl({value: '', disabled: false}, Validators.required)
        });
    }

    private onSubmit(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.disable();
        this.submitted = true;
        if(this.signinForm.invalid === true) {
            this.submitted = false;
            this.enable();
            return;
        }
        this.http.post(environment.endpoint+'/auth/sign-in', {email: this.signinForm.controls['email'].value, password: this.signinForm.controls['password'].value})
            .map(
                res => res.json(),
                err => err.json()
            )
            .subscribe(
                res => {
                    if(res.status === 'OK') {
                        localStorage.setItem('amt_flyer_token', res.results);
                        this.router.navigate(['/dashboard'])
                    }else
                        this.errors.generic = res.results;
                    this.submitted = false;
                    this.enable();
                },
                err => {
                    this.errors.generic = 'There was an error signing in . Please try again.';
                    this.submitted = false;
                    this.enable();
                }
            );
    }

    private disable(): void {
        for(let control in this.signinForm.controls)
            this.signinForm.controls[control].disable();
    }

    private enable(): void {
        for(let control in this.signinForm.controls)
            this.signinForm.controls[control].enable();
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts